import { render, staticRenderFns } from "./SituacionLaboralUpdate.vue?vue&type=template&id=2c6e393c&scoped=true"
import script from "./SituacionLaboralUpdate.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e393c",
  null
  
)

export default component.exports